const pad = (n) => String(n).padStart(2, "0");

const toUTC = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

const calendarInfo = (ev) => {
  if (!ev.sale_start) return null;
  const start = new Date(ev.sale_start);
  const end = new Date(start.getTime() + 30 * 60000);
  return {
    title: `Kaartverkoop ${ev.name}`,
    details: `De kaartverkoop voor ${ev.name} start nu!${ev.ticket_url ? ` Tickets: ${ev.ticket_url}` : ""}`,
    location: [ev.venue, ev.city].filter(Boolean).join(", "),
    start,
    end,
  };
};

export const googleCalendarUrl = (ev) => {
  const info = calendarInfo(ev);
  if (!info) return null;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: info.title,
    dates: `${toUTC(info.start)}/${toUTC(info.end)}`,
    details: info.details,
    location: info.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const downloadIcs = (ev) => {
  const info = calendarInfo(ev);
  if (!info) return false;
  const esc = (s) => s.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//wanneerkaartverkoop.nl//NL",
    "BEGIN:VEVENT",
    `UID:${ev.id}@wanneerkaartverkoop`,
    `DTSTAMP:${toUTC(new Date())}`,
    `DTSTART:${toUTC(info.start)}`,
    `DTEND:${toUTC(info.end)}`,
    `SUMMARY:${esc(info.title)}`,
    `DESCRIPTION:${esc(info.details)}`,
    `LOCATION:${esc(info.location)}`,
    "BEGIN:VALARM",
    "TRIGGER:-PT15M",
    "ACTION:DISPLAY",
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `kaartverkoop-${ev.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return true;
};
